import React from "react";
import { useNavigate } from "react-router-dom";
import BrandDesignHero from "../components/brand-design-hero";
import ColorPalette from "../components/color-palette";
import ScrollToTopButton from "../components/scroll-to-top-btn";

import studio from "../assets/studio.jpg";
import logo from "../assets/AA_Logo.png";
import marbleBg from "../assets/black-marble-texture-background.jpg";
import website from "../assets/archer-arts.mp4";
import businessCards from "../assets/aa-business-cards.jpg";
import leaflets from "../assets/aa-leaflets.jpg";

const ArcherArts: React.FC = () => {
  const navigate = useNavigate();

  const colors = [
    { bgClass: "bg-orange", hexColor: "#D3843A" },
    { bgClass: "bg-lightOrange", hexColor: "#E3AA6F" },
    { bgClass: "bg-brown", hexColor: "#775A5A" },
    { bgClass: "bg-purple", hexColor: "#473844" },
  ];

  return (
    <div className="mx-10 md:mx-20 my-10">
      <button className="font-frank text-white text-lg hover:underline" onClick={() => navigate("/")}>← Back to Home</button>

      <h1 className="font-euro text-white text-3xl mt-8 mb-3">Archer Arts</h1>
      <div className="border-t-4 border-orange"></div>
      <p className="text-white font-frankbook text-lg mt-5 mb-10">I created my own branding, assets, and website for my music production work. As the owner, I combined my skills in design, marketing, and of course production to craft the brand and advertising materials. Utilising my industry knowledge and understanding of how artists tick, I crafted branding to feel relatable and personable. Having the freedom to express myself through the brand expanded my design expertise and solidified my client base. </p>

      <BrandDesignHero
        background={studio}
        logo={logo}
        name="Archer Arts"
      />

      <ColorPalette background={marbleBg} colors={colors} />

      <h3 className="font-euro text-white text-2xl mt-6 mb-3">Brand Kit</h3>

      <table className="text-white text-lg lg:text-xl w-full mt-3">
        <tr>
          <td className="font-euro border-2 border-orange p-5">Typography</td>
          <td className="border-2 border-orange p-5">
            <p className="font-euro">Eurostile Extended</p>
            <p className="font-frankbook">Franklin Gothic</p>
          </td>
        </tr>
        <tr>
          <td className="font-euro border-2 border-orange p-5">Colour Palette</td>
          <td className="border-2 border-orange p-5">
            <p className="font-frankbook"><strong>Orange - </strong>Positive energy / transformation / confidence</p>
            <p className="font-frankbook"><strong>Purple - </strong>Creativity / ambition / innovation</p>
            <p className="font-frankbook"><strong>Brown - </strong>Authenticity / strength / experience</p>
          </td>
        </tr>
      </table>


      <h2 className="font-euro text-white text-center text-3xl mt-14 mb-3">Web Design</h2>
      <div className="border-t-2 border-orange mb-5"></div>
      <video controls autoPlay muted><source src={website}></source></video>
      <p className="text-white font-frankbook bg-purple p-5">I created a custom website to showcase my production services, fully integrating my personal branding to promote my skills and experience as an audio engineer. The website serves as both a portfolio and a professional introduction, reflecting my unique style and expertise in the audio production industry. From the layout to the visual elements, every aspect was carefully designed to highlight my work, including past projects, photos of the studio I worked in, and the range of services I offer.</p>

      <h2 className="font-euro text-white text-center text-3xl mt-14 mb-3">Collateral</h2>
      <div className="border-t-2 border-orange mb-5"></div>

      <p className="text-white font-frankbook text-lg mb-5">Professional printed collateral, such as business cards and posters, played a key role in promoting Archer Arts, creating a tangible connection that encouraged potential clients to get in touch. These materials were thoughtfully designed to reflect the brand’s identity, ensuring consistency with my online presence and reinforcing awareness of my services.</p>
      <div className="grid md:grid-cols-2 gap-4 mb-40">
        <img src={businessCards} alt="Business cards" className="w-full h-auto aspect-[1/1] object-cover" />
        <img src={leaflets} alt="Leaflets" className="w-full h-auto aspect-[1/1] object-cover" />
      </div>

      <ScrollToTopButton />
    </div>
  );
};

export default ArcherArts;
